import React from 'react';
import PropTypes from 'prop-types';
import IssuePreviewDetailsTab from './IssuePreviewDetailsTab';
import IssuePreviewAttachmentsTab from './IssuePreviewAttachmentsTab';
import IssuePreviewActivityTabContainer from './IssuePreviewActivityTabContainer';
import {issueAttributesType, pendingIssueFormAttributesType} from '../../constants/proptype-validation';
import {PreviewNavigationTabIds} from '../../constants/navigation';

const IssuePreviewSelectedTab = ({
  issue,
  container,
  selectedTabId,
  disableKeyboard,
  activityCommentEditorState,
  contentElementRef
}) => {
  switch (selectedTabId) {
    case PreviewNavigationTabIds.DETAILS:
      return <IssuePreviewDetailsTab issue={issue} container={container} contentElementRef={contentElementRef} />;
    case PreviewNavigationTabIds.ATTACHMENTS:
      return <IssuePreviewAttachmentsTab issue={issue} container={container} />;
    case PreviewNavigationTabIds.ACTIVITY:
      return (
        <IssuePreviewActivityTabContainer
          issue={issue}
          disableKeyboard={disableKeyboard}
          container={container}
          activityCommentEditorState={activityCommentEditorState}
          saveActivityCommentEditorState={editorState => (activityCommentEditorState = editorState)}
          contentElementRef={contentElementRef}
        />
      );
    default:
      return null;
  }
};

IssuePreviewSelectedTab.displayName = 'IssuePreviewSelectedTab';

IssuePreviewSelectedTab.propTypes = {
  issue: PropTypes.oneOfType([issueAttributesType, pendingIssueFormAttributesType]),
  container: PropTypes.object.isRequired,
  selectedTabId: PropTypes.oneOf(Object.values(PreviewNavigationTabIds)),
  disableKeyboard: PropTypes.func,
  activityCommentEditorState: PropTypes.object,
  contentElementRef: PropTypes.object
};

export default IssuePreviewSelectedTab;
